/* キービジュアル start */
$(document).ready(function () {
  if ($('#kv-slide').length) {
    $('#kv-slide').on('init', function () {
      $(this).css({
        opacity: 1,
        visibility: 'visible'
      });
    });

    $('#kv-slide').slick({
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: true,
      dots: true,
      fade: false
    });
  }
});
/* キービジュアル end */
/* おすすめ商品 start */
$(document).ready(function () {
  $('.js-collection-slider').on('init', function () {
    $(this).css({
      opacity: 1,
      visibility: 'visible'
    });
  });

  $('.js-collection-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});
/* おすすめ商品 end */

/* 私たちの特徴 start */
$(function() {
    let tabs = $(".tab");
    $(".tab").on("click", function() {
        $(".active").removeClass("active");
        $(this).addClass("active");
        const index = tabs.index(this);
        $(".content").removeClass("show").eq(index).addClass("show");
    });
});
/* 私たちの特徴 end */
